/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { NgcErrorModule } from '../error/ngc-error.component';
// JQX Widget
import { jqxComboBoxComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxcombobox';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcComboBoxComponent),
    multi: true
};

/**
 * Combo Box
 */

export class NgcComboBoxComponent extends ControlComponent {
     animationType: any;
     autoComplete: any;
     autoOpen: any;
     autoItemsHeight: any;
     autoDropDownHeight: any;
     closeDelay: any;
     checkboxes: any;
     displayMember: any;
     dropDownHorizontalAlignment: any;
     dropDownVerticalAlignment: any;
     dropDownHeight: any;
     dropDownWidth: any;
     enableHover: any;
     enableSelection: any;
     enableBrowserBoundsDetection: any;
     itemHeight: any;
     multiSelect: any;
     minLength: any;
     openDelay: any;
     popupZIndex: any;
     placeHolder: any;
     remoteAutoComplete: any;
     remoteAutoCompleteDelay: any;
     renderer: any;
     renderSelectedItem: any;
     rtl: any;
     selectedIndex: any;
     showArrow: any;
     showCloseButtons: any;
     searchMode: any;
     search: any;
     source: any;
     scrollBarSize: any;
     template: any;
     theme: any;
     validateSelection: any;
     valueMember: any;
     width: any;
     height: any;
     autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * On Input Change
     * 
     * @param Event
     */
    inputChange($e) {
        this.value = $e.target.value;
    }

    /**
     * On Select
     * 
     * @param Event
     */
    select($e) {
        if ($e.args.item !== null) {
            this.value = $e.args.item.value;
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngc-combobox',
    template: `<jqxComboBox *ngIf="visible" (change)="inputChange($event)" (onSelect)="select($event)"
                [animationType] = "animationType"
                [autoComplete] = "autoComplete"
                [autoOpen] = "autoOpen"
                [autoItemsHeight] = "autoItemsHeight"
                [autoDropDownHeight] = "autoDropDownHeight"
                [closeDelay] = "closeDelay"
                [checkboxes] = "checkboxes"
                [disabled] = "disabled"
                [displayMember] = "displayMember"
                [dropDownHorizontalAlignment] = "dropDownHorizontalAlignment"
                [dropDownVerticalAlignment] = "dropDownVerticalAlignment"
                [dropDownHeight] = "dropDownHeight"
                [dropDownWidth] = "dropDownWidth"
                [enableHover] = "enableHover"
                [enableSelection] = "enableSelection"
                [enableBrowserBoundsDetection] = "enableBrowserBoundsDetection"
                [itemHeight] = "itemHeight"
                [multiSelect] = "multiSelect"
                [minLength] = "minLength"
                [openDelay] = "openDelay"
                [popupZIndex] = "popupZIndex"
                [placeHolder] = "placeHolder"
                [remoteAutoComplete] = "remoteAutoComplete"
                [remoteAutoCompleteDelay] = "remoteAutoCompleteDelay"
                [renderer] = "renderer"
                [renderSelectedItem] = "renderSelectedItem"
                [rtl] = "rtl"
                [selectedIndex] = "selectedIndex"
                [showArrow] = "showArrow"
                [showCloseButtons] = "showCloseButtons"
                [searchMode] = "searchMode"
                [search] = "search"
                [source] = "source"
                [scrollBarSize] = "scrollBarSize"
                [template] = "template"
                [theme] = "theme"
                [validateSelection] = "validateSelection"
                [valueMember] = "valueMember"
                [width] = "width"
                [height] = "height">
                </jqxComboBox>
                <ngc-error *ngIf="visible" [value]="error"></ngc-error>
                `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'animationType': [{ type: Input, args: ['animationType', ] },],
'autoComplete': [{ type: Input, args: ['autoComplete', ] },],
'autoOpen': [{ type: Input, args: ['autoOpen', ] },],
'autoItemsHeight': [{ type: Input, args: ['autoItemsHeight', ] },],
'autoDropDownHeight': [{ type: Input, args: ['autoDropDownHeight', ] },],
'closeDelay': [{ type: Input, args: ['closeDelay', ] },],
'checkboxes': [{ type: Input, args: ['checkboxes', ] },],
'displayMember': [{ type: Input, args: ['displayMember', ] },],
'dropDownHorizontalAlignment': [{ type: Input, args: ['dropDownHorizontalAlignment', ] },],
'dropDownVerticalAlignment': [{ type: Input, args: ['dropDownVerticalAlignment', ] },],
'dropDownHeight': [{ type: Input, args: ['dropDownHeight', ] },],
'dropDownWidth': [{ type: Input, args: ['dropDownWidth', ] },],
'enableHover': [{ type: Input, args: ['enableHover', ] },],
'enableSelection': [{ type: Input, args: ['enableSelection', ] },],
'enableBrowserBoundsDetection': [{ type: Input, args: ['enableBrowserBoundsDetection', ] },],
'itemHeight': [{ type: Input, args: ['itemHeight', ] },],
'multiSelect': [{ type: Input, args: ['multiSelect', ] },],
'minLength': [{ type: Input, args: ['minLength', ] },],
'openDelay': [{ type: Input, args: ['openDelay', ] },],
'popupZIndex': [{ type: Input, args: ['popupZIndex', ] },],
'placeHolder': [{ type: Input, args: ['placeHolder', ] },],
'remoteAutoComplete': [{ type: Input, args: ['remoteAutoComplete', ] },],
'remoteAutoCompleteDelay': [{ type: Input, args: ['remoteAutoCompleteDelay', ] },],
'renderer': [{ type: Input, args: ['renderer', ] },],
'renderSelectedItem': [{ type: Input, args: ['renderSelectedItem', ] },],
'rtl': [{ type: Input, args: ['rtl', ] },],
'selectedIndex': [{ type: Input, args: ['selectedIndex', ] },],
'showArrow': [{ type: Input, args: ['showArrow', ] },],
'showCloseButtons': [{ type: Input, args: ['showCloseButtons', ] },],
'searchMode': [{ type: Input, args: ['searchMode', ] },],
'search': [{ type: Input, args: ['search', ] },],
'source': [{ type: Input, args: ['source', ] },],
'scrollBarSize': [{ type: Input, args: ['scrollBarSize', ] },],
'template': [{ type: Input, args: ['template', ] },],
'theme': [{ type: Input, args: ['theme', ] },],
'validateSelection': [{ type: Input, args: ['validateSelection', ] },],
'valueMember': [{ type: Input, args: ['valueMember', ] },],
'width': [{ type: Input, args: ['width', ] },],
'height': [{ type: Input, args: ['height', ] },],
'autoCreate': [{ type: Input, args: ['auto-create', ] },],
};
}

/**
 * Combo Box Module
 */

export class NgcComboBoxModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, NgcErrorModule],
    exports: [NgcComboBoxComponent],
    declarations: [NgcComboBoxComponent, jqxComboBoxComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
